import React, { useContext } from 'react'

import AccordionContext from './Accordion.Context'
import * as S from './Accordion.styled'

interface BodyProps {
  accordionId?: string
  className?: string
}

const AccordionBody: React.FC<BodyProps> = ({
  className,
  accordionId,
  children
}) => {
  const { isExpanded } = useContext(AccordionContext)

  return (
    <S.Collapse
      id={`collapse-${accordionId}`}
      className={className}
      aria-labelledby={`heading-${accordionId}`}
      role="region"
      animate={isExpanded(accordionId) ? 'open' : 'collapsed'}
      initial="collapsed"
      exit="collapsed"
      transition={{ duration: 0.2 }}
      variants={{
        open: { opacity: 1, height: 'auto' },
        collapsed: { opacity: 0, height: 0 }
      }}
    >
      <S.Body>{children}</S.Body>
    </S.Collapse>
  )
}

export default AccordionBody
